import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';

import sizeStyles from './style/size.css';
import colorStyles from './style/color.css';
import weightStyles from './style/weight.css';

const headingStyles = { ...sizeStyles, ...colorStyles, ...weightStyles };
const cx = classNames.bind(headingStyles);

/**
 * The heading component provides a quick way to style any title with a font
 * size from our typography scale, color from our color palette and HTML tag
 * of choice.
 */
export default function Heading({ children, color, id, size, tag, weight }) {
  const headingProps = {
    className: cx(size, color, weight, tag),
    id,
  };

  const CustomTag = tag;

  return <CustomTag {...headingProps}>{children}</CustomTag>;
}

Heading.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  color: PropTypes.oneOf([
    'black',
    'steel',
    'slate',
    'silver',
    'smoke',
    'darkSmoke',
    'extraDarkSmoke',
    'snow',
    'darkSnow',
    'extraDarkSnow',
    'white',
  ]),
  id: PropTypes.string,
  size: PropTypes.oneOf([
    'xxxxl',
    'xxxl',
    'xxl',
    'xl',
    'l',
    'm',
    's',
    'xs',
    'xxs',
  ]),
  tag: PropTypes.oneOf(['div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired, // required to prevent miss-use of title hierarchy for SEO
  weight: PropTypes.oneOf(['regular', 'semibold', 'bold']),
};

Heading.defaultProps = {
  size: 'l',
  color: 'black', // this should default to #darkest when included in styleguide
  weight: 'regular',
  tag: 'div',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-heading/Heading/index.js